const convertYouTubeUrl = (url: string) => {
    const hasAutoplay = url.includes("autoplay=1");
    if (!hasAutoplay) {
        // Handle YouTube watch URLs - convert to embed format
        const youtubeWatchScript = url.includes("youtube") && !url.includes("embed");
        if (youtubeWatchScript) {
            const videoIdMatch = url.match(/(?:v=|\/)([0-9A-Za-z_-]{11})(?:&|$)/);
            const videoId = videoIdMatch ? videoIdMatch[1] : null;
            if (videoId) {
                return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
            }
        }
        // For other URLs, append autoplay parameter
        const separator = url.includes("?") ? "&" : "?";
        return `${url}${separator}autoplay=1`;
    }
    return url;
};

const performClose = (modal: HTMLElement) => {
    const videoContainer = modal.querySelector('.general-modal-bg__video-container');
    if (videoContainer) {
        videoContainer.innerHTML = '';
    }
    modal.classList.add("general-modal-bg--hidden");
};

export const closeVideoModal = () => {
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
            const modal = document.querySelector<HTMLElement>('.general-modal-bg');
            const videoContainer = modal?.querySelector('.general-modal-bg__video-container');
            if (modal && !modal.classList.contains("general-modal-bg--hidden") && videoContainer) {
                performClose(modal);
            }
        }
    });

    document.body.addEventListener("click", (e) => {
        const target = e.target as HTMLElement;
        if (target.classList.contains("general-modal-bg") && target.querySelector('.general-modal-bg__video-container')) {
            performClose(target);
        }
    });
};

export const initializeVideoBannerModal = () => {
    const playButton = document.querySelector<HTMLButtonElement>('.banner-video__play-button');
    const modal = document.querySelector<HTMLElement>('.general-modal-bg');
    
    if (!playButton || !modal) {
        console.log('Play button or modal not found');
        return;
    }

    playButton.addEventListener('click', () => {
        const videoLink = playButton.dataset.video;
        
        if (videoLink) {
            const existingIframe = modal.querySelector('iframe');
            if (existingIframe) {
                existingIframe.remove();
            }

            const embedUrl = convertYouTubeUrl(videoLink);
            const iframe = document.createElement('iframe');
            iframe.src = embedUrl;
            iframe.width = '100%';
            iframe.height = '100%';
            iframe.title = 'YouTube video player';
            iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
            iframe.setAttribute('referrerPolicy', 'strict-origin-when-cross-origin');
            iframe.setAttribute('allowfullscreen', '');
            iframe.style.border = 'none';
            
            modal.innerHTML = '';
            const innerDiv = document.createElement('div');
            innerDiv.className = 'general-modal-bg__video-container';
            innerDiv.appendChild(iframe);
            modal.appendChild(innerDiv);
        }
        
        modal.classList.remove('general-modal-bg--hidden');
    });
};